import { registerQuery } from 'data-fetching-client';
import { fetchSmsCampaignDetails } from '../clients/fetchSmsCampaignDetails';
export const FETCH_SMS_CAMPAIGN_DETAILS_QUERY_NAME = 'fetchSmsCampaignDetails';
export const FETCH_SMS_CAMPAIGN_DETAILS_QUERY = registerQuery({
  fieldName: FETCH_SMS_CAMPAIGN_DETAILS_QUERY_NAME,
  args: ['contentId'],
  fetcher: fetchSmsCampaignDetails
});